import styled from "styled-components";

export const Section = styled.section`
  position: relative;
  width: 100%;
  padding-bottom: 4rem;
  overflow-x: hidden;
`;

export const BannerBg = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
  width: 100%;
  height: 350px;
  background: var(--color-secondary);
  border-radius: 0 0 160px 160px;
  pointer-events: none;

  &::before {
    content: "";
    display: block;
    width: 100%;
    height: 300px;
    background: var(--color-primary);
    border-radius: 0 0 160px 160px;
  }
`;

export const PagePad = styled.div`
  position: relative;
  z-index: 1;
  width: 100%;
  padding-left: 1rem;
  padding-right: 1rem;

  @media (min-width: 1024px) {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  @media (min-width: 1536px) {
    padding-left: 8rem;
    padding-right: 8rem;
  }
`;

export const TitleBlock = styled.div`
  padding-top: 6rem;
`;

export const Title = styled.h3`
  font-size: 1.125rem;
  font-weight: 500;
  color: #fff;
  line-height: 1.35;

  b {
    font-weight: 700;
  }

  @media (min-width: 1024px) {
    font-size: 1.25rem;
  }

  @media (min-width: 1280px) {
    font-size: 1.5rem;
  }

  @media (min-width: 1536px) {
    font-size: 2.25rem;
  }
`;

export const TitleRow = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-top: 1rem;
  width: 100%;
  gap: 0.75rem;

  @media (min-width: 1024px) {
    flex-direction: row;
    align-items: center;
  }
`;

export const LocationLabel = styled.p`
  font-size: 0.875rem;
  font-weight: 500;
  color: #fff;

  @media (min-width: 1024px) {
    font-size: 1rem;
  }

  @media (min-width: 1280px) {
    font-size: 1.125rem;
  }

  @media (min-width: 1536px) {
    font-size: 1.25rem;
  }
`;

export const ActionButtons = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-left: auto;
  padding-top: 1rem;

  @media (min-width: 1024px) {
    margin-left: 0;
    padding-top: 0;
  }
`;

export const CircleBtn = styled.button`
  width: 1.5rem;
  height: 1.5rem;
  display: grid;
  place-items: center;
  background: #fff;
  border: none;
  border-radius: 9999px;
  color: var(--color-primary);
  cursor: pointer;
  padding: 0;
  flex-shrink: 0;

  svg {
    width: 0.85rem;
    height: 0.85rem;
  }

  @media (min-width: 1024px) {
    width: 2rem;
    height: 2rem;

    svg {
      width: 1.1rem;
      height: 1.1rem;
    }
  }

  &:hover {
    opacity: 0.9;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const GallerySection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding-top: 2rem;
  padding-bottom: 2rem;
`;

export const GalleryRow = styled.div`
  display: flex;
  align-items: stretch;
  gap: 1rem;
`;

export const GalleryMain = styled.div<{ $hasVideo?: boolean }>`
  width: 100%;
  height: 300px;
  border-radius: 1rem;
  border: 1px solid #fff;
  overflow: ${({ $hasVideo }) => ($hasVideo ? "visible" : "hidden")};
  position: relative;
  background: var(--color-surface);
  cursor: ${({ $hasVideo }) => ($hasVideo ? "default" : "pointer")};

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .player-wrapper {
    position: relative;
    z-index: 1;
    width: 100%;
    height: 100%;
    pointer-events: auto;
  }

  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    pointer-events: auto;
  }

  @media (min-width: 1024px) {
    width: 50%;
    height: 400px;
  }

  @media (min-width: 1536px) {
    width: 60%;
    height: 500px;
  }
`;

export const GalleryThumbs = styled.div`
  display: none;

  @media (min-width: 1024px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
    width: 50%;
    height: 400px;
  }

  @media (min-width: 1536px) {
    width: 40%;
    height: 500px;
  }
`;

export const GalleryThumb = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 1rem;
  border: 1px solid #fff;
  overflow: hidden;
  background: var(--color-surface);
  cursor: pointer;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const GalleryMobile = styled.div`
  display: block;
  width: 100%;
  border-radius: 1rem;
  overflow: hidden;

  .carousel .slide img {
    height: 280px;
    object-fit: cover;
  }

  @media (min-width: 1024px) {
    display: none;
  }
`;

export const GalleryDesktopOnly = styled.div`
  display: none;
  width: 100%;

  @media (min-width: 1024px) {
    display: flex;
    align-items: stretch;
    gap: 1rem;
  }
`;

export const MorePhotosBtn = styled.button`
  position: absolute;
  right: 1rem;
  bottom: 1rem;
  z-index: 10;
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  border: none;
  border-radius: 9999px;
  background: rgba(14, 34, 68, 0.85);
  color: #fff;
  padding: 0.45rem 0.85rem;
  font-size: 0.8rem;
  font-weight: 500;
  cursor: pointer;
  pointer-events: auto;
  transition: background 0.3s ease;

  &:hover {
    background: rgba(14, 34, 68, 1);
  }
`;

export const ShareToolbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 1rem;
`;

export const ShareCircleBtn = styled.button`
  width: 1.5rem;
  height: 1.5rem;
  display: grid;
  place-items: center;
  background: var(--color-secondary);
  border: none;
  border-radius: 9999px;
  color: #fff;
  cursor: pointer;
  padding: 0;
  flex-shrink: 0;
  transition: background 0.3s ease;

  &:hover {
    background: var(--color-primary);
  }

  svg {
    width: 0.85rem;
    height: 0.85rem;
  }

  @media (min-width: 1024px) {
    width: 2rem;
    height: 2rem;

    svg {
      width: 1.1rem;
      height: 1.1rem;
    }
  }

  a& {
    text-decoration: none;
  }
`;

export const ShareCircleLink = styled.a`
  width: 1.5rem;
  height: 1.5rem;
  display: grid;
  place-items: center;
  background: var(--color-secondary);
  border-radius: 9999px;
  color: #fff;
  flex-shrink: 0;
  transition: background 0.3s ease;

  &:hover {
    background: var(--color-primary);
  }

  svg {
    width: 0.85rem;
    height: 0.85rem;
  }

  @media (min-width: 1024px) {
    width: 2rem;
    height: 2rem;

    svg {
      width: 1.1rem;
      height: 1.1rem;
    }
  }
`;

export const DownloadBtn = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  background: var(--color-secondary);
  border: none;
  border-radius: 9999px;
  padding: 0.5rem 1rem;
  color: #fff;
  cursor: pointer;
  transition: background 0.3s ease;

  &:hover {
    background: var(--color-primary);
  }

  @media (min-width: 1024px) {
    margin-left: 1rem;
  }

  p,
  span {
    font-size: 0.75rem;
    font-weight: 500;
    color: #fff;

    @media (min-width: 1024px) {
      font-size: 0.875rem;
    }

    @media (min-width: 1280px) {
      font-size: 1rem;
    }
  }

  svg {
    width: 1rem;
    height: 1rem;

    @media (min-width: 1024px) {
      width: 1.25rem;
      height: 1.25rem;
    }
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const Columns = styled.div`
  display: flex;
  flex-direction: column-reverse;
  gap: 2rem;
  padding-bottom: 4rem;

  @media (min-width: 1024px) {
    flex-direction: row;
  }
`;

export const LeftCol = styled.aside`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4rem;

  @media (min-width: 1024px) {
    width: 70%;
  }
`;

export const RightCol = styled.aside`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4rem;

  @media (min-width: 1024px) {
    width: 30%;
  }
`;

export const Block = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const BlockTitle = styled.h4`
  font-size: 1.125rem;
  font-weight: 700;
  color: var(--color-primary);

  @media (min-width: 1024px) {
    font-size: 1.25rem;
  }

  @media (min-width: 1280px) {
    font-size: 1.5rem;
  }
`;

export const MetaRow = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding-top: 0.5rem;

  p {
    font-size: 0.75rem;
    font-weight: 500;
    color: var(--color-primary);

    @media (min-width: 1024px) {
      font-size: 0.875rem;
    }

    @media (min-width: 1280px) {
      font-size: 1rem;
    }
  }
`;

export const BodyText = styled.p`
  font-size: 0.75rem;
  color: var(--color-primary);
  line-height: 1.55;
  white-space: pre-wrap;

  @media (min-width: 1024px) {
    font-size: 0.875rem;
  }

  @media (min-width: 1280px) {
    font-size: 1rem;
  }
`;

export const OverviewGrid = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;

  @media (min-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

export const OverviewItem = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 0.5rem;

  @media (min-width: 1024px) {
    gap: 1rem;
  }
`;

export const OverviewIcon = styled.div`
  width: 1rem;
  height: 1rem;
  display: grid;
  place-items: center;
  color: var(--color-primary);
  flex-shrink: 0;

  svg {
    width: 100%;
    height: 100%;
  }

  @media (min-width: 1024px) {
    width: 1.5rem;
    height: 1.5rem;
  }
`;

export const OverviewText = styled.div`
  p {
    font-size: 0.75rem;
    color: var(--color-primary);
    line-height: 1.3;

    @media (min-width: 1024px) {
      font-size: 0.875rem;
    }

    @media (min-width: 1280px) {
      font-size: 1rem;
    }

    &:first-child {
      font-weight: 600;
      text-transform: uppercase;
    }
  }
`;

export const SaibaMaisCard = styled.div`
  width: 100%;
  min-height: 170px;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  border-radius: 1rem;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);
  padding: 1rem;
  background: #fff;

  @media (min-width: 1024px) {
    flex-direction: column;
  }
`;

export const SaibaMaisTabs = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  @media (min-width: 1024px) {
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.5rem 1rem;
  }
`;

export const SaibaMaisTab = styled.button<{ $active?: boolean }>`
  font-size: 0.75rem;
  font-weight: 600;
  border-radius: 0.75rem;
  border: none;
  padding: 0.5rem;
  cursor: pointer;
  transition: all 0.3s;
  color: ${({ $active }) =>
    $active ? "var(--color-secondary)" : "var(--color-primary)"};
  background: ${({ $active }) => ($active ? "var(--color-surface)" : "#fff")};

  @media (min-width: 1024px) {
    font-size: 0.875rem;
  }

  @media (min-width: 1280px) {
    font-size: 1rem;
    padding: 0.5rem 1rem;
  }

  &:hover {
    background: var(--color-surface);
  }
`;

export const SaibaMaisItems = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  @media (min-width: 1024px) {
    min-height: 64px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 0.5rem;

    @media (min-width: 1280px) {
      gap: 1rem;
    }
  }
`;

export const SaibaMaisItem = styled.div`
  width: 100%;
  min-height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 0.5rem;

  @media (min-width: 1024px) {
    justify-content: flex-start;
    height: 100%;
  }

  @media (min-width: 1280px) {
    padding: 0 1rem;
  }

  p {
    font-size: 0.75rem;
    color: var(--color-primary);
    text-transform: lowercase;

    &:first-letter {
      text-transform: uppercase;
    }

    @media (min-width: 1024px) {
      font-size: 0.875rem;
    }

    @media (min-width: 1280px) {
      font-size: 1rem;
    }
  }
`;

export const LocationLines = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const LocationLine = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;

  @media (min-width: 1024px) {
    gap: 1rem;
  }

  svg {
    width: 1rem;
    height: 1rem;
    color: var(--color-primary);
    flex-shrink: 0;

    @media (min-width: 1024px) {
      width: 1.5rem;
      height: 1.5rem;
    }
  }

  p {
    font-size: 0.75rem;
    color: var(--color-primary);

    @media (min-width: 1024px) {
      font-size: 0.875rem;
    }

    @media (min-width: 1280px) {
      font-size: 1rem;
    }

    b {
      font-weight: 700;
    }
  }
`;

export const MapSlot = styled.div`
  width: 100%;
  height: 300px;
  background: var(--color-surface);
  border-radius: 1rem;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);
  overflow: hidden;

  .leaflet-container {
    width: 100%;
    height: 100%;
    border-radius: 1rem;
  }

  @media (min-width: 1024px) {
    height: 500px;
  }
`;

export const PriceBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  .from {
    font-size: 0.875rem;
    font-weight: 500;
    color: var(--color-primary);

    @media (min-width: 1024px) {
      font-size: 1rem;
    }

    @media (min-width: 1280px) {
      font-size: 1.125rem;
    }
  }

  .price-row {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .price {
    font-size: 1.5rem;
    font-weight: 700;
    color: var(--color-primary);

    @media (min-width: 1024px) {
      font-size: 1.875rem;
    }

    @media (min-width: 1280px) {
      font-size: 2.25rem;
    }
  }

  .note {
    font-size: 0.75rem;
    font-weight: 500;
    color: var(--color-primary);
    padding-top: 0.5rem;
  }
`;

export const ScheduleDesktop = styled.div`
  display: none;

  @media (min-width: 1024px) {
    display: flex;
    flex-direction: column;
    border-radius: 1rem;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);
  }
`;

export const ScheduleMobile = styled.div`
  display: block;
  padding-bottom: 2rem;

  > div {
    width: 100%;
    border-radius: 1rem;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);
  }

  @media (min-width: 1024px) {
    display: none;
  }
`;

export const ScheduleInner = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 1rem;
  background: #fff;
  border-radius: 20px;

  h4 {
    font-size: 1rem;
    font-weight: 600;
    color: var(--color-primary);
    text-align: center;
    margin: 1rem 0 1.5rem;
  }

  .broker {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    margin-bottom: 0.75rem;

    img,
    .avatar {
      width: 48px;
      height: 48px;
      border-radius: 9999px;
      object-fit: cover;
      color: var(--color-primary);
    }

    h3,
    h2 {
      font-size: 0.95rem;
      font-weight: 600;
      color: var(--color-primary);
      cursor: pointer;
    }

    p {
      font-size: 0.75rem;
      color: var(--color-primary);
      opacity: 0.85;
    }
  }

  .text-and-check {
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: flex-end;
    gap: 0.5rem;
    margin: 0 0 1rem;

    p {
      font-size: 0.8rem;
      margin: 0;
      color: var(--color-font-footer);
    }
  }

  input[type="text"],
  input[type="email"],
  input[type="time"],
  textarea {
    width: 100%;
    height: 50px;
    padding-left: 1rem;
    margin-bottom: 1.5rem;
    border: 1px solid rgba(0, 0, 0, 0.09);
    border-radius: 6px;
    background-color: #f8f8f8;
    font-size: 0.875rem;
    color: var(--color-primary);
    font-family: "Montserrat", sans-serif;

    &::placeholder {
      color: var(--color-placeholder-input);
    }
  }

  textarea {
    height: auto;
    min-height: 120px;
    padding-top: 0.8rem;
    margin-bottom: 0.8rem;
    resize: vertical;
  }

  .div-calendar {
    width: 100%;
    margin-bottom: 1rem;

    .react-calendar {
      width: 100% !important;
      border: none;
      border-radius: 6px;
      font-family: "Montserrat", sans-serif;
      background: #fff;
    }

    .react-calendar__tile--active,
    .react-calendar__tile--range,
    .react-calendar__tile:enabled:focus {
      background-color: var(--color-primary) !important;
      color: #fff;
    }

    .react-calendar__tile--now {
      background: var(--gray-one);
    }

    .react-calendar__tile:enabled:hover {
      background-color: #e6e6e6;
    }
  }

  .privacy {
    font-size: 0.75rem;
    text-align: center;
    color: var(--color-font-footer);

    a {
      text-decoration: underline;
      color: var(--color-primary);
    }
  }
`;

export const RelatedSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding-top: 2rem;
  padding-bottom: 4rem;
`;

export const CtaSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding-bottom: 4rem;
`;

export const FinancingCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  border-radius: 1rem;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);
  padding: 2rem 1rem;
  background: #fff;

  @media (min-width: 1024px) {
    width: 66.666%;
    padding: 2rem;
  }

  @media (min-width: 1280px) {
    padding: 2rem 4rem;
  }

  @media (min-width: 1536px) {
    width: 50%;
  }
`;

export const FinancingTitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;

  @media (min-width: 1280px) {
    gap: 0.75rem;
  }

  h4 {
    font-size: 1.125rem;
    font-weight: 700;
    color: var(--color-primary);

    @media (min-width: 1024px) {
      font-size: 1.25rem;
    }

    @media (min-width: 1280px) {
      font-size: 1.5rem;
    }

    @media (min-width: 1536px) {
      font-size: 1.875rem;
    }
  }

  img {
    width: auto;
    height: 1.5rem;

    @media (min-width: 1024px) {
      height: 2rem;
    }

    @media (min-width: 1280px) {
      height: 2.5rem;
    }

    @media (min-width: 1536px) {
      height: 3rem;
    }
  }
`;

export const FinancingSubtitle = styled.p`
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--color-secondary);

  @media (min-width: 1024px) {
    font-size: 1rem;
  }

  @media (min-width: 1280px) {
    font-size: 1.125rem;
  }

  @media (min-width: 1536px) {
    font-size: 1.25rem;
  }
`;

export const FinancingActions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;

  @media (min-width: 1024px) {
    flex-direction: row;
    gap: 2rem;
  }
`;

export const FinancingBtn = styled.a`
  width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(14, 34, 68, 0.25);
  border-radius: 0.75rem;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
  padding: 0.5rem;
  font-size: 1rem;
  font-weight: 500;
  color: var(--color-secondary);
  background: #fff;
  transition: all 0.3s;
  text-align: center;
  cursor: pointer;

  @media (min-width: 1024px) {
    padding: 0.5rem 1rem;
    font-size: 1.125rem;
  }

  @media (min-width: 1280px) {
    font-size: 1.25rem;
  }

  @media (min-width: 1536px) {
    font-size: 1.5rem;
  }

  &:hover {
    background: var(--color-secondary);
    color: #fff;
  }

  &.primary {
    @media (min-width: 1024px) {
      width: 66.666%;
    }
  }

  &.secondary {
    @media (min-width: 1024px) {
      width: 33.333%;
    }
  }
`;

export const ProblemsCard = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.25rem;
  background: var(--color-surface);
  border-radius: 1rem;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);
  padding: 1.5rem 1rem;
  overflow: hidden;

  @media (min-width: 768px) {
    padding: 2rem;
  }

  @media (min-width: 1024px) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 2rem;
  }

  @media (min-width: 1536px) {
    padding: 3rem 4rem;
    gap: 3rem;
  }
`;

export const ProblemsContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  width: 100%;
  min-width: 0;

  @media (min-width: 1024px) {
    align-items: flex-start;
    flex: 1;
  }

  @media (min-width: 1280px) {
    gap: 1.5rem;
  }
`;

export const ProblemsTitleRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  width: 100%;

  @media (min-width: 1024px) {
    flex-direction: row;
    gap: 1rem;
  }

  svg {
    width: 1.5rem;
    height: 1.5rem;
    color: var(--color-primary);
    flex-shrink: 0;
  }

  h4 {
    font-size: 1rem;
    font-weight: 600;
    color: var(--color-secondary);
    text-align: center;
    margin: 0;
    line-height: 1.35;

    @media (min-width: 1024px) {
      text-align: left;
    }

    @media (min-width: 1280px) {
      font-size: 1.25rem;
    }

    @media (min-width: 1536px) {
      font-size: 1.5rem;
    }
  }
`;

export const ProblemsLinks = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  width: 100%;

  @media (min-width: 1024px) {
    align-items: flex-start;
    gap: 1rem;
  }

  @media (min-width: 1280px) {
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    gap: 1rem 2rem;
  }

  @media (min-width: 1536px) {
    gap: 1rem 3rem;
  }

  button {
    border: none;
    background: transparent;
    font-size: 0.75rem;
    font-weight: 500;
    color: var(--color-secondary);
    text-decoration: underline;
    cursor: pointer;
    text-align: center;
    padding: 0;
    max-width: 100%;
    white-space: normal;

    @media (min-width: 1024px) {
      font-size: 0.875rem;
      text-decoration: none;
      text-align: left;

      &:hover {
        text-decoration: underline;
      }
    }

    @media (min-width: 1280px) {
      font-size: 1rem;
    }
  }
`;

export const ProblemsImage = styled.img`
  display: block;
  width: min(220px, 70vw);
  height: auto;
  max-height: 160px;
  object-fit: contain;
  flex-shrink: 0;
  pointer-events: none;

  @media (min-width: 768px) {
    width: min(240px, 40%);
    max-height: 180px;
  }

  @media (min-width: 1024px) {
    width: 200px;
    max-height: 200px;
  }

  @media (min-width: 1280px) {
    width: 240px;
    max-height: 240px;
  }

  @media (min-width: 1536px) {
    width: 280px;
    max-height: 280px;
  }
`;

export const PdfLinkBtn = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  margin-top: 0.75rem;
  border: none;
  background: transparent;
  color: var(--color-primary);
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  padding: 0;
  text-decoration: underline;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;
